import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-copomatrix',
  templateUrl: './copomatrix.component.html',
  styleUrls: ['./copomatrix.component.scss'],
   providers:[MasterService]
})
export class CopomatrixComponent implements OnInit {

 
     memberdetails:any[]=[];
     classdetails:any[]=[];
     arrashead:any=[];
     arrastype:any=[];
     closeResult: string;
     classes: any=[];
     section: any=[];
     arrcourse:any=[];
     arrsubcomb:any=[];
     student:boolean=true;
     staff:boolean=false;
     memberdash:any={};
     objass:any={};
     objastype:any={};
     objfiltmat:any={};
     arreval:any=[];
     arrcomat:any=[];
     arrcat:any=[];
     arract:any=[{name:'Yes'},{name:'No'}];
     arrledom:any=[{id:'0',name:'-'},{id:'1',name:'1'},{id:'2',name:'2'},{id:'3',name:'3'}];
     objmethod:any={};
     objpo:any={};
     objlevel:any={};
     objco:any={};
     modalOptions:NgbModalOptions;
     private modalRef: NgbModalRef;
   objfiltmat1: any={};
  oprtype: string;
  enbtn: boolean;
   // objfiltmat: any;
   
     constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
   
     open(content) {
       this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
         this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
         this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
     }
   
     private getDismissReason(reason: any): string {
       if (reason === ModalDismissReasons.ESC) {
         return 'by pressing ESC';
       } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
         return 'by clicking on a backdrop';
       } else {
         return `with: ${reason}`;
       }
     }
   
   
   
     ngOnInit(): void {
       
       this.getcourses();
     }
   
   
     masclass() {
       this.mservice.masclass()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.classes = resultArray;
               this.objfiltmat.clid=resultArray[0].clid;
               // this.getobemco(this.objfiltmat);
               this.SelectClsSubDetails();
           },
           error => console.log("Error :: " + error)
           )
     }
   
     private getcourses() {
   
       this.mservice.getcourse()
     .subscribe((result:any) => {
     
     this.arrcourse=result;
     this.objfiltmat.crid=result[0].crid;
     this.objfiltmat1.crid=result[0].crid;
     this.masclass();
     
     }, error => {
     
     //alert('error in r');
     // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
     }
     );
       
       
     }
 
     
   
     massection() {
       this.mservice.massection()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.section = resultArray;
              
           },
           error => console.log("Error :: " + error)
           )
     }
 
        
        
 
      getobemcomatrix(obj) {
       this.mservice.getobemtcopo(obj,'selcomatrx')
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               
               if ( resultArray)
               {
               if (resultArray.length>0)
               {
                this.enbtn=true;
                this.oprtype="updcopo";
               this.arrcomat = resultArray;
               }
               else 
               {
                 this.arrcomat = [];
                this.enbtn=false;
               }
              }

               else 
               {
this.getobemconotexist(obj)

               }
           },
           error => console.log("Error :: " + error)
           )
     }

     SelectClsSubDetails() {
      debugger
      //var clid = this.clid;
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var clssubdata = { clid:this.objfiltmat.clid,clcd:clcd,aycd:aycd,crid:this.objfiltmat.crid };
      console.log('model', clssubdata);
      this.mservice.masclasssubject(clssubdata)
          .subscribe(resultArray => {
              console.log('classsubs', resultArray);
              this.arrsubcomb = resultArray;
              this.objfiltmat.suid=resultArray[0].suid;
              this.getobemcomatrix(this.objfiltmat);
              //alert (resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
      //this.closeAddExpenseModal.nativeElement.click();
  }
    

     getobemconotexist(obj) {
       this.mservice.getobemtcopo(obj,'selcos')
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               if (resultArray)
               {
                this.enbtn=true;
                this.oprtype="inscopo";
               this.arrcomat = resultArray;
               }
               else
               {
                this.enbtn=false;
                this.arrcomat = [];
               }
              
           },
           error => console.log("Error :: " + error)
           )
     }
 
    
     includeorexclude(objdata,oprtype)
     {
       if(confirm(" Are you sure you wan't to "+oprtype))
       {
         objdata.oprtype=oprtype;
         objdata.clid=this.objfiltmat.clid;
         objdata.crid=this.objfiltmat.crid;
         objdata.sucbid=this.objfiltmat.sucbid;
         objdata.asid=this.objfiltmat.asid;
         objdata.astpid=this.objfiltmat.astpid;
   
         //this.saveevpattern(objdata);
       }
     }
   
     updatedet(objdata,oprtype)
     {
       
         objdata.oprtype=oprtype;
         objdata.clid=this.objfiltmat.clid;
         objdata.crid=this.objfiltmat.crid;
         objdata.sucbid=this.objfiltmat.sucbid;
         objdata.asid=this.objfiltmat.asid;
         objdata.astpid=this.objfiltmat.astpid;
         //this.saveevpattern(objdata);
       
     }
   
     
 
     
   
   
   saveobemcopo()
   {
  //  console.log('saveobj',this.objco);
  var pst={stuarr:this.arrcomat,crid:this.objfiltmat.crid,clid:this.objfiltmat.clid,suid:this.objfiltmat.suid,oprtype:this.oprtype};
     this.mservice.saveobemcopo(pst)
         .subscribe(
         result => {
             console.log('SavegenmasDetails', result);
             //this.suppliers = resultArray;
             alert(result.message);
             if(result.status=='Success')
             {
              //  let localmodref=this.modalRef;
              //  localmodref.close();
             //  this.masasstype();
             this.getobemcomatrix(this.objfiltmat);
             }
            else
            {
   
            }
         },
         error =>{ alert('Error While saving...');}
         )
   }
 
 
 
  
 
 
   }
   
 
